import type { TranslatedString } from "@deskpro-product/messenger-api-schemas/messenger/config/common";
import { useCallback } from "react";
import { useIntl } from "react-intl";

/**
 * Return the correct translation from the config for the current locale
 */
export default function useGetTranslation(): (translations?: TranslatedString) => string {
  const locale = useIntl().locale;
  return useCallback(
    (translations?: TranslatedString) => {
      if (!translations) return "";
      const translation = translations?.find((t) => t.locale === locale);
      return translation?.value || "Missing translation";
    },
    [locale],
  );
}
